module.exports = __webpack_public_path__ + "static/img/swiper4.225ea272.png";